var render, staticRenderFns
import script from "./SingleBarChart.vue?vue&type=script&lang=js&"
export * from "./SingleBarChart.vue?vue&type=script&lang=js&"
import style0 from "./SingleBarChart.vue?vue&type=style&index=0&id=1f351388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f351388",
  null
  
)

export default component.exports